import { pdkAxios } from '@/lib/pdk-axios.ts';
import { dealStore } from '@/models/stores';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';

type ArchiveInput = {
  dealId: string;
  reason?: string;
};

export function useArchiveDealMutation() {
  const queryClient = useQueryClient();

  const archiveDealMutation = useMutation({
    mutationFn: async (input: ArchiveInput) => {
      const response = await pdkAxios.post(`/deals/${input.dealId}/archive`, {
        id: uuidv4(),
        reason: input.reason,
        source: 'manual',
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['archivedDeals'], exact: false });
    },
  });

  const unarchiveDealMutation = useMutation({
    mutationFn: async (input: { dealId: string }) => {
      const response = await pdkAxios.post(
        `deals/${input.dealId}/unarchive`,
        {},
      );
      return response.data;
    },
    onSuccess: (_, { dealId }) => {
      queryClient.invalidateQueries({
        queryKey: ['archivedDeals'],
        exact: false,
      });
      dealStore.removeArchivedDealById(dealId);
    },
  });

  return { archiveDealMutation, unarchiveDealMutation };
}
